import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const bioPakSignupManagementRoute: RouteConfig<'with-page'> = {
    name: 'Signups',
    path: '/biopak/signups',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin', 'bioPakEmployee'],
}